import { useEffect, useState } from "react";
import Container from "@/components/Container";
import { api } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";

const SECTIONS = [
  { key: "home", title: "Homepage", fields: ["hero_overline","hero_headline","hero_subline","hero_image","cta_primary","cta_secondary","cta_tertiary","featured_overline","featured_title","featured_copy"] },
  { key: "about", title: "About", fields: ["headline","body"] },
  { key: "contact", title: "Contact", fields: ["headline","body","email"] },
  { key: "footer", title: "Footer", fields: ["text","tagline"] },
  { key: "seo", title: "SEO", fields: ["title","description","og_image"] },
];

export default function WebsiteCMSAdmin() {
  const [data, setData] = useState({});
  useEffect(() => { api.get("/cms").then(r => setData(r.data || {})); }, []);

  const save = async (key) => {
    await api.put(`/cms/${key}`, data[key] || {});
    toast.success(`${key} saved`);
  };
  const setField = (sec, field, value) => setData(d => ({ ...d, [sec]: { ...(d[sec]||{}), [field]: value } }));

  return (
    <Container className="py-8 md:py-12">
      <p className="overline">Library</p>
      <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Website CMS</h1>

      <div className="mt-8 space-y-6">
        {SECTIONS.map(sec => (
          <div key={sec.key} className="luxury-card p-6">
            <p className="overline">{sec.title}</p>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              {sec.fields.map(f => {
                const value = data[sec.key]?.[f] || "";
                const isLong = f.includes("body") || f.includes("copy") || f.includes("description") || f.includes("subline");
                return (
                  <label key={f} className={isLong ? "md:col-span-2 block" : "block"}>
                    <span className="overline">{f.replace(/_/g," ")}</span>
                    {isLong ? (
                      <textarea rows={3} className="mt-2 w-full bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" value={value} onChange={e => setField(sec.key, f, e.target.value)} />
                    ) : (
                      <input className="mt-2 w-full bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" value={value} onChange={e => setField(sec.key, f, e.target.value)} />
                    )}
                  </label>
                );
              })}
            </div>
            <button onClick={() => save(sec.key)} className="btn-ruby mt-5" data-testid={sec.key === "home" ? ADMIN.saveCmsHome : `cms-save-${sec.key}`}>Save {sec.title}</button>
          </div>
        ))}
      </div>
    </Container>
  );
}
